export const getContentFromValues = (values?: string[]) => {
  if (values) {
    if (values.length === 0) {
      return undefined;
    } else if (values.length === 1) {
      return values[0];
    } else {
      return `${values[0]} +${values.length - 1}`;
    }
  }
  return undefined;
};
